// Types
import type { ICharacteristcsProps } from "./types";

export function Characteristcs({REP_PROJECT,infocusID}: ICharacteristcsProps) {

    return (
       <div data-infocusID={infocusID === 3}
          className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-16 p-16 bg-white
                page-break
            "
        >
            <div className="flex-1 w-full max-h-[45%] flex flex-row flex-nowrap">
                <span className="flex-1 h-auto flex flex-col justify-between gap-4 pt-16 pb-12">
                    <span className="w-full h-auto flex flex-col  gap-4">
                        <span className="text-5xl">Características do</span>
                        <span className="text-5xl font-bold">Projeto</span>
                    </span>

                    <span className="font-normal text-2xl">Atualmente {REP_PROJECT?.name || 'N/A'} conta com:</span>
                </span>
                <span className="flex-1 rounded-bl-[70px] bg-slate-200" style={{
                    // @ts-ignore
                    backgroundImage: `url("${process.env.REACT_APP_API_URL}/builders/real-estate-products/${REP_PROJECT?.id || -1}/photo")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                </span>
            </div>

            <span className="h-64 w-full flex flex-row flex-wrap items-start gap-x-4 gap-y-2 pr-16 self-center overflow-y-auto">
                {
                    REP_PROJECT?.condominium_options?.map((coption, index) => (
                        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
<span key={index} className="min-w-full md:min-w-[15%] flex  flex-row items-center justify-start gap-4">
                            {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                            <span className="w-10 h-10 rounded-md bg-[#079269]"></span>
                            <span className="overflow-hidden text-ellipsis whitespace-nowrap text-xl font-normal">
                                {coption.option}
                            </span>
                        </span>
                    ))
                }
            </span>
        </div>
    )
}
